// Lazy loaders for the diceware word lists. Each list is a separate chunk so it
// is only fetched when the passphrase mode is used. Load failures throw loudly so
// the UI can show an error instead of producing a weak passphrase (plan FINDING-10).
//
// Sources: EFF large wordlist (EN) and dys2p de-7776-v1 (DE), both 7776 words.

export const WORDLIST_SIZE = 7776;

export type WordlistLang = 'de' | 'en';

export async function loadWordlist(lang: WordlistLang): Promise<string[]> {
  try {
    const mod =
      lang === 'de'
        ? await import('./de.json')
        : await import('./en.json');
    const words = (mod.default ?? mod) as string[];
    if (!Array.isArray(words) || words.length === 0) {
      throw new Error('word list is empty or malformed');
    }
    return words;
  } catch (cause) {
    throw new Error(`Failed to load the ${lang} word list`, { cause });
  }
}
